import { useId } from "react";

/** Labelled form control. as = input | select | textarea */
export default function Field({ label, error, hint, as = "input", className = "", children, ...props }) {
  const id = useId();
  const common = { id, "aria-invalid": Boolean(error), ...props };
  const control =
    as === "select" ? (
      <select className="select" {...common}>
        {children}
      </select>
    ) : as === "textarea" ? (
      <textarea className="textarea" {...common} />
    ) : (
      <input className="input" {...common} />
    );
  return (
    <div className={`field ${error ? "has-error" : ""} ${className}`}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      {control}
      {error ? <span className="field-error">{error}</span> : hint ? <span className="hint">{hint}</span> : null}
    </div>
  );
}
